__turbopack_context__.v({
  "className": "paperlogy_f50d0399-module__3GqYaG__className",
  "variable": "paperlogy_f50d0399-module__3GqYaG__variable",
});
